var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{on:{"input":_vm.updateSelection},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }